import { observer } from 'mobx-react';
import ReadyModal from './ReadyModal';
import { just } from 'maybeasy';
import { whenLte } from '@execonline-inc/numbers';
import ModalStore from '../../../../../../../../../../../../Modal/Store';
import { LearningCollectionPublishResource } from '../../../../../../Store/Types';
import LicenseExpiredModal from './LicenseExpiredModal';
import InviteParticipantStore from '../../../Store';
import { SelectParticipantsState } from '../../../Store/Types';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  state: SelectParticipantsState;
}

function ModalContent({ store, modalStore, learningCollectionPublishResource, state }: Props) {
  return just(state.daysUntilRenewal)
    .andThen(whenLte(0))
    .map(() => <LicenseExpiredModal close={modalStore.close} title={state.publicName} />)
    .getOrElse(() => (
      <ReadyModal
        modalStore={modalStore}
        state={state}
        learningCollectionPublishResource={learningCollectionPublishResource}
        store={store}
      />
    ));
}

export default observer(ModalContent);
